"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Configurator;

var _react = require("@chakra-ui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _admin = require("../context/admin");

var _inputReducer = require("../reducers/input-reducer");

var _constants = require("../utils/constants");

var _shortcode = require("../utils/shortcode");

var _colorPalette = _interopRequireDefault(require("./color-palette"));

var _cssReset = _interopRequireDefault(require("./css-reset"));

var _measurements = _interopRequireDefault(require("./measurements"));

var _flaggPanel = _interopRequireDefault(require("./panels/flagg-panel"));

var _measurementsPanel = _interopRequireDefault(require("./panels/measurements-panel"));

var _sprojsPanel = _interopRequireDefault(require("./panels/sprojs-panel"));

var _visualiser = _interopRequireDefault(require("./visualiser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Configurator(_ref) {
  var _ref$admin = _ref.admin,
      admin = _ref$admin === void 0 ? false : _ref$admin,
      _ref$watermarkUrl = _ref.watermarkUrl,
      watermarkUrl = _ref$watermarkUrl === void 0 ? "/logo.png" : _ref$watermarkUrl;

  var _useReducer = (0, _react2.useReducer)(_inputReducer.inputReducer, _inputReducer.initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      measurements = _useReducer2$.measurements,
      sprojs = _useReducer2$.sprojs,
      flagg = _useReducer2$.flagg,
      farg = _useReducer2$.farg,
      visualizerInput = _useReducer2$.valid,
      validations = _useReducer2$.validations,
      errors = _useReducer2$.errors,
      dispatch = _useReducer2[1];

  var hasError = Object.values(errors).some(function (error) {
    return error;
  });

  var _useState = (0, _react2.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      code = _useState2[0],
      setCode = _useState2[1];

  var mailtoLink = (0, _react2.useMemo)(function () {
    var code = (0, _shortcode.generateCodeFromInput)(visualizerInput);
    var body = encodeURIComponent("Hej,\n\nMeddela oss g\xE4rna eventuella \xF6vriga \xF6nskem\xE5l \xE4n utseende i detta mail samt skriv med ditt telefonnr ifall du vill, s\xE5 kan vi l\xE4ttare kontakta dig vid eventuella fr\xE5gor.\n\nTack f\xF6r att du kontaktar oss!\nMed v\xE4nlig h\xE4lsning A-Kvalit\xE9 F\xF6nster & D\xF6rrar\n\n_______________________________________________\n\nInkludera f\xF6ljande kod i meddelandet s\xE5 vi vet vad du \xF6nskar f\xF6r utf\xF6rande: ".concat(code, "\n\t\t"));
    var email = "offert@akvalite.se";
    var subject = "Offertförfrågan";
    return "mailto:".concat(email, "?subject=").concat(subject, "&body=").concat(body);
  }, [visualizerInput]);

  function onCodeSubmit(event) {
    event.preventDefault();
    dispatch({
      type: _inputReducer.ACTION.SUBMIT_CODE,
      payload: code
    });
    setCode("");
  }

  return /*#__PURE__*/_react2.default.createElement(_admin.AdminContext.Provider, {
    value: admin
  }, /*#__PURE__*/_react2.default.createElement("chakra-scope", null, /*#__PURE__*/_react2.default.createElement(_react.ChakraProvider, {
    resetCSS: false
  }, /*#__PURE__*/_react2.default.createElement(_cssReset.default, null), admin ? /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    as: "form",
    maxW: "sm",
    marginBottom: 12,
    onSubmit: onCodeSubmit
  }, /*#__PURE__*/_react2.default.createElement(_react.FormControl, null, /*#__PURE__*/_react2.default.createElement(_react.FormLabel, null, "Infoga kod"), /*#__PURE__*/_react2.default.createElement(_react.Input, {
    placeholder: "V=1000,H=800,X=1,Y=1,L=2,C=#FEFFFE",
    value: code,
    onChange: function onChange(e) {
      return setCode(e.target.value);
    }
  })), /*#__PURE__*/_react2.default.createElement(_react.Button, {
    type: "submit"
  }, "Till\xE4mpa")) : null, /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    className: "configurator",
    gap: 8,
    flexFlow: "row wrap"
  }, /*#__PURE__*/_react2.default.createElement(_react.Box, {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: ["100%", "340px"],
    maxW: "md",
    maxH: "500px"
  }, /*#__PURE__*/_react2.default.createElement(_react.AspectRatio, {
    ratio: 4 / 3
  }, /*#__PURE__*/_react2.default.createElement(_visualiser.default, {
    input: visualizerInput,
    watermarkUrl: watermarkUrl
  }))), /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "300px",
    direction: "column",
    spacing: 8
  }, /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    as: "form",
    direction: "column",
    spacing: 4,
    onSubmit: function onSubmit(event) {
      return event.preventDefault();
    }
  }, /*#__PURE__*/_react2.default.createElement(_react.Tabs, {
    variant: "soft-rounded",
    colorScheme: "blue"
  }, /*#__PURE__*/_react2.default.createElement(_react.TabList, {
    m: -3,
    p: 3,
    overflowX: "auto",
    sx: {
      scrollbarWidth: "none",
      "::-webkit-scrollbar": {
        display: "none"
      }
    }
  }, /*#__PURE__*/_react2.default.createElement(_react.Tab, {
    bg: errors.measurements ? "orange.100" : null
  }, "M\xE5tt"), /*#__PURE__*/_react2.default.createElement(_react.Tab, {
    bg: errors.sprojs ? "orange.100" : null
  }, "Spr\xF6js"), /*#__PURE__*/_react2.default.createElement(_react.Tab, {
    bg: errors.flagg ? "orange.100" : null
  }, "Flaggf\xF6nster"), /*#__PURE__*/_react2.default.createElement(_react.Tab, null, "F\xE4rg")), /*#__PURE__*/_react2.default.createElement(_react.TabPanels, null, /*#__PURE__*/_react2.default.createElement(_react.TabPanel, null, /*#__PURE__*/_react2.default.createElement(_measurementsPanel.default, {
    value: measurements,
    minLuft: validations.measurements.luft.min,
    maxLuft: validations.measurements.luft.max,
    minV: validations.measurements.v.min,
    maxV: validations.measurements.v.max,
    minH: validations.measurements.h.min,
    maxH: validations.measurements.h.max,
    onChange: function onChange(value) {
      return dispatch({
        type: _inputReducer.ACTION.SET_MEASUREMENTS,
        payload: value
      });
    }
  })), /*#__PURE__*/_react2.default.createElement(_react.TabPanel, null, /*#__PURE__*/_react2.default.createElement(_sprojsPanel.default, {
    value: sprojs,
    maxX: validations.sprojs.x.max,
    onChange: function onChange(value) {
      return dispatch({
        type: _inputReducer.ACTION.SET_SPROJS,
        payload: value
      });
    }
  })), /*#__PURE__*/_react2.default.createElement(_react.TabPanel, null, /*#__PURE__*/_react2.default.createElement(_flaggPanel.default, {
    value: flagg,
    maxSprojsX: validations.flagg.sprojs.x.max,
    karmV: measurements.v,
    luft: measurements.luft,
    onChange: function onChange(value) {
      return dispatch({
        type: _inputReducer.ACTION.SET_FLAGG,
        payload: value
      });
    }
  })), /*#__PURE__*/_react2.default.createElement(_react.TabPanel, null, /*#__PURE__*/_react2.default.createElement(_react.FormControl, null, /*#__PURE__*/_react2.default.createElement(_colorPalette.default, {
    id: "color",
    value: farg,
    colors: _constants.COLORS,
    onChange: function onChange(val) {
      return dispatch({
        type: _inputReducer.ACTION.SET_COLOR,
        payload: val
      });
    }
  }))))), /*#__PURE__*/_react2.default.createElement(_react.Link, {
    alignSelf: "start",
    href: mailtoLink,
    target: "_blank"
  }, /*#__PURE__*/_react2.default.createElement(_react.Button, {
    isDisabled: hasError
  }, "Beg\xE4r offert"))), admin ? /*#__PURE__*/_react2.default.createElement(_measurements.default, {
    input: visualizerInput
  }) : null)))));
}